import { commits, getters } from '@/modules/core/app/helpers/store';

export const mutations = {
  setWidgetAsRendered(state, { widgetId }) {
    const copy = new Set([...state.unrenderedWidgets.values()]);
    copy.delete(Number(widgetId));
    state.unrenderedWidgets = copy;
  },
  setUnrenderedWidgetIds(state, { widgetIds }) {
    state.unrenderedWidgets = new Set([
      ...state.unrenderedWidgets.values(),
      ...widgetIds.map((widgetId) => Number(widgetId)),
    ]);
  },
  setWidgetAsReadyToPaginate(state, { widgetId }) {
    state.readyToPaginateWidgets[widgetId] = true;
  },
  setPaginationRequiredWidgets(state, { widgetIds }) {
    widgetIds.forEach((widgetId) => {
      state.readyToPaginateWidgets[widgetId] = false;
    });
  },
  setPaginationTargetNumber(state, { count }) {
    state.paginationTarget = count;
  },
  removeFromPaginationRequired(state, { widgetId }) {
    const updatedPaginationRequired = { ...state.readyToPaginateWidgets };
    delete updatedPaginationRequired[widgetId];

    state.readyToPaginateWidgets = updatedPaginationRequired;

    state.paginationTarget -= 1;
  },
  setPaginationReady(state) {
    state.isReadyToPaginate = true;
  },
  addToPaginationQueue(state, { widgetId, ref }) {
    state.paginationQueue[widgetId] = ref;
  },
  pushMeasuredObjects(state, { layoutId, measuredObject }) {
    if (!Object.hasOwn(state.measuredElements, layoutId)) {
      state.measuredElements[layoutId] = [];
    }

    state.measuredElementsCounter += 1;
    if (getters.dashboardExport.paginationIsReadyToDisplay()) {
      commits.dashboardExport.setIsReadyToDisplay();
    }

    state.measuredElements[layoutId].push(measuredObject);
  },
  setIsReadyToDisplay(state) {
    state.isReadyToDisplay = true;
  },
  addExecutiveSummaryToQueue(state, { executiveSummary }) {
    state.executiveSummaryQueue.push(executiveSummary);
  },
};
